import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import AiQuoteDialog from "../components/AiQuoteDialog";
import { Button } from "../components/ui/button";
import { Sparkles, ArrowLeft, CheckCircle } from "lucide-react";
import { SERVICE_IMAGES } from "../lib/api";

const CONTENT = {
  "climatizzazione": { name: "Climatizzazione", desc: "Installazione, manutenzione e assistenza di condizionatori, pompe di calore e impianti VRV/VRF per abitazioni, uffici e attività commerciali.", features: ["Split, multi-split, canalizzati", "Pompe di calore e riscaldamento", "Manutenzione periodica", "Partner Daikin"] },
  "sistemi-allarme": { name: "Sistemi d'allarme", desc: "Progettazione e installazione di sistemi antifurto certificati per casa e azienda.", features: ["Centraline via radio / filo", "Sensori volumetrici e perimetrali", "App di controllo", "Assistenza 24/7"] },
  "antincendio": { name: "Antincendio", desc: "Impianti di rilevazione fumo, spegnimento e sistemi di sicurezza antincendio a norma.", features: ["Rilevatori certificati EN54", "Estinguenti automatici", "Manutenzione programmata"] },
  "sistemi-sicurezza": { name: "Sistemi di sicurezza", desc: "Videosorveglianza IP, controllo accessi e sistemi integrati.", features: ["Telecamere IP HD/4K", "NVR e cloud", "Controllo accessi"] },
  "settore-elettrico": { name: "Settore elettrico", desc: "Impianti elettrici civili e industriali, quadri, cablaggi, certificazioni.", features: ["Certificazione DM 37/08", "Quadri industriali", "Illuminotecnica"] },
  "automazione": { name: "Automazione", desc: "Cancelli, tapparelle, portoni automatici. Partner CAME.", features: ["Cancelli scorrevoli e battenti", "Tapparelle motorizzate", "Portoni sezionali"] },
  "luce-gas": { name: "Luce e gas", desc: "Consulenza e attivazione forniture luce e gas, cambio fornitore, ottimizzazione bolletta.", features: ["Cambio fornitore", "Analisi consumi", "Contratti dedicati"] },
  "fotovoltaico": { name: "Fotovoltaico", desc: "Impianti fotovoltaici chiavi in mano con accumulo, monitoraggio e ottimizzatori.", features: ["Pannelli monocristallini", "Sistemi di accumulo", "Monitoraggio remoto", "Detrazioni fiscali"] },
  "idraulica": { name: "Idraulica", desc: "Impianti idraulici civili, sanitari, riscaldamento a pavimento e caldaie a condensazione.", features: ["Caldaie a condensazione", "Riscaldamento a pavimento", "Impianti sanitari"] },
};

export default function ServiceDetail() {
  const { slug } = useParams();
  const [aiOpen, setAiOpen] = useState(false);
  const s = CONTENT[slug];
  if (!s) {
    return (
      <div className="min-h-screen"><Navbar/><div className="max-w-4xl mx-auto p-12">Servizio non trovato. <Link to="/" className="text-blue-800">Torna alla home</Link></div></div>
    );
  }
  return (
    <div className="min-h-screen">
      <Navbar />
      <section className="relative ew-hero-overlay">
        <img src={SERVICE_IMAGES[s.name]} alt={s.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-20">
          <Link to="/" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 text-sm" data-testid="back-home-link">
            <ArrowLeft className="w-4 h-4" /> Tutti i servizi
          </Link>
          <h1 className="heading text-4xl md:text-6xl font-extrabold text-white tracking-tight">{s.name}</h1>
          <p className="mt-4 max-w-2xl text-slate-200 leading-relaxed">{s.desc}</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="heading text-3xl font-extrabold text-slate-900 mb-6">Cosa facciamo</h2>
            <ul className="space-y-3">
              {s.features.map((f, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-700">
                  <CheckCircle className="w-5 h-5 text-blue-800 mt-0.5 flex-shrink-0" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-slate-50 rounded-md p-8 border border-slate-200">
            <h3 className="heading text-2xl font-extrabold text-slate-900">Pronto per un preventivo?</h3>
            <p className="mt-3 text-slate-600">Racconta la tua esigenza al nostro assistente IA. Bastano poche risposte.</p>
            <Button onClick={() => setAiOpen(true)} data-testid="service-ai-quote-btn"
                    className="mt-6 bg-amber-500 hover:bg-amber-600 text-white font-semibold w-full py-6">
              <Sparkles className="w-4 h-4 mr-2" /> Richiedi in modo semplice
            </Button>
          </div>
        </div>
      </section>
      <AiQuoteDialog open={aiOpen} onOpenChange={setAiOpen} />
    </div>
  );
}
